import React from "react";

export const ContainerInformationProjectDetails = ({ name = "", className = "", children }) => {
	return (
		<div className={`w-full overflow-hidden flex flex-col gap-2 ${className}`}>
			<div className="w-full h-[16px]">
				<span className="text-[10px]">{name}</span>
			</div>
			{children}
		</div>
	);
};
